/**
 * Email one-time-code configuration.
 *
 * Supabase Auth generates the code that goes out in the signup-confirmation and
 * magic-link emails; nothing in this repo generates it. Its length is the
 * project's `mailer_otp_length` setting, which lives in two places that MUST
 * agree with the value below:
 *
 *   - Local dev:  `[auth.email].otp_length` in supabase/config.toml
 *   - Hosted:     Dashboard -> Authentication -> Email OTP length
 *                 (Management API: PATCH /v1/projects/<ref>/config/auth)
 *
 * These drifted apart once: the hosted project was left on 8 after the
 * East -> West migration while the verify screens still rendered 6 boxes, so
 * the code in the email could never be entered and email signup was a dead end.
 * tests/utils/email-otp-length.test.ts locks this constant to config.toml; the
 * hosted setting has no in-repo representation, so it has to be checked by hand
 * when it changes.
 */
export const EMAIL_OTP_LENGTH = 6;

/** Empty per-digit state for the split-box OTP inputs. */
export const createEmptyOtpDigits = (): string[] =>
  Array<string>(EMAIL_OTP_LENGTH).fill("");
